import { Boss } from './boss.js';

// Dedicated phase-2 boss script.
// Forces final-boss behavior so summon/lock logic cannot be affected by
// accidental phase wiring in spawners.
export class BossPhase2 extends Boss {
  constructor({ scene, x, z, audio, fbx }) {
    super({
      scene,
      x,
      z,
      audio,
      fbx,
      phase: 2,
    });
    this._phase2MovesSnapshot = Array.isArray(this.moves) ? [...this.moves] : [];
    this._summonDeckDisabled = false;
  }

  _isSummonWindowActive() {
    if (this._isSummoningHidden) return true;
    if ((this._pendingSummonDrops || 0) > 0) return true;
    if (Array.isArray(this._activeSummonAdds) && this._activeSummonAdds.some((e) => e?.alive)) return true;
    return false;
  }

  updateAI(dt, game) {
    const summonWindowActive = this._isSummonWindowActive();
    if (summonWindowActive) {
      if (!this._summonDeckDisabled) {
        this.moves = [];
        this._summonDeckDisabled = true;
      }
      this._movePattern = null;
      this._moveStep = 0;
      this._stepTimer = 0;
      this._aimDelay = 0;
      this._slashActive = false;
      this._pendingMelee = -1;
      this.fireCd = Math.max(this.fireCd, this.stats.fireCooldown * 3);
      this._setBossState('idle');
      return;
    }
    if (this._summonDeckDisabled) {
      this.moves = [...this._phase2MovesSnapshot];
      this._summonDeckDisabled = false;
    }
    super.updateAI(dt, game);
  }

  _executePattern(dt, game) {
    const summonWindowActive = this._isSummonWindowActive();
    if (summonWindowActive || !this.moves.length) {
      this._movePattern = null;
      this.fireCd = Math.max(this.fireCd, this.stats.fireCooldown * 3);
      this._setBossState('idle');
      return;
    }
    super._executePattern(dt, game);
  }
}

